/**
 *
 LogHistory
 *
 */

import React, { memo, useContext, useEffect, useState } from "react";
import classNames from "classnames";

// styles
import "./style.scss";

// antd component
import { Link, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { Spin } from "antd";
import { http } from "../../../engine/api/http";
import useAsync from "../../../engine/hooks/useAsync";
import {
  apiUrl,
  daysJsFormat,
  renderUserName,
  roles,
} from "../../../utils/constants";
import dayjs from "../../../utils/dayjs";
import { UserContext } from "../../../engine/context/User.context";
import routes from "../../../engine/routes";

// icons
//import CustomIcons from 'components/CustomIcons';

function LogHistory({
  item,
  updateEndPoint,
  ready = true,
  label = "Dernière modification par",
  route,
  linkType = "list",
}) {
  const location = useLocation();
  const { id } = useParams();

  const params = useParams();

  const { user } = useContext(UserContext);

  const { isLoading, isSuccess, run, data } = useAsync();

  const [randomKey, setRandomKey] = useState(null);

  // Define a callback function to handle saga actions
  const handleSagaAction = action => {
    // Handle the saga action here
  };

  // Use the custom hook to listen for all saga actions with "SUCCESS" in the type

  const getPath = () => {
    const pathname = location.pathname; // Get the pathname from location object
    const pathSegments = pathname.split("/"); // Split the pathname into an array of segments
    const route = pathSegments[1]; // Access the second segment, which is "uni"

    switch (route) {
      case "prestations":
        return "prestations";
      case "institutions":
        return "institutions";
      case "principals":
        return "principals";
      case "interpretes":
        return "users";
      case "billing":
        return "bills";
    }
  };

  const doTheRun = () => {
    const url = `${apiUrl()}/logs/search`;

    const body = {
      baseUrl: `/api/${getPath()}`,
      entityId: params.id,
    };

    if (getPath() === "bills" || getPath() === "users") {
      // Add special type
      body.route = route;
    }

    run(
      http.post(url, body).then(res => {
        return res.data;
      }),
    );
  };

  const isNew = location.pathname.split("/")[2]; // Get the pathname from location object

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    if (ready && isNew !== "new") {
      doTheRun();
    }
  }, [ready]);

  useEffect(() => {
    if (ready && isNew !== "new") {
      doTheRun();
    }
  }, [...updateEndPoint, isNew]);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */

  const adminLog = () => {
    let path = "";
    const pathname = location.pathname; // Get the pathname from location object
    const pathSegments = pathname.split("/"); // Split the pathname into an array of segments
    const route = pathSegments[1]; // Access the second segment, which is "uni"

    switch (route) {
      case "prestations":
        path = "prestations";
      case "institutions":
        path = "institutions";
      case "principals":
        path = "principals";
      case "interpretes":
        path = "users";
      case "logs":
        path = "logs";
    }

    let link = "";

    if (route !== undefined && linkType === "detail") {
      link = `${routes.logs(data[0]?._id).detail.path}`;
    } else {
      link = `${routes.logs().list.path}?entityId=${id}&path=${path}`;
    }

    return data.length > 0 ? (
      <Link style={{ fontSize: "14px", marginBottom: 0 }} to={link}>
        {data.map(
          e =>
            `${label} :  ${renderUserName(e.user)} à ${dayjs(
              e.createdAt,
            ).format(daysJsFormat.full)}`,
        )}
      </Link>
    ) : null;
  };

  const renderLog = () => {
    return data.length > 0 ? (
      <p style={{ fontSize: "14px", marginBottom: 0 }}>
        {data.map(
          e =>
            `${label} :  ${renderUserName(e.user)} à ${dayjs(
              e.createdAt,
            ).format(daysJsFormat.full)}`,
        )}
      </p>
    ) : null;
  };

  return (
    <div style={{ width: "100%", textAlign: "right" }}>
      {isSuccess ? (
        user.role === roles.admin ? (
          adminLog()
        ) : (
          renderLog()
        )
      ) : isLoading ? (
        <Spin style={{ width: "100%", textAlign: "right" }} />
      ) : null}
    </div>
  );
}

LogHistory.propTypes = {};

LogHistory.defaultProps = {
  item: { itemsCallBack: () => {} },
  updateEndPoint: [],
};

export default LogHistory;
